// extracted by mini-css-extract-plugin
export default {"button":"BuyButton_button__0bTi+","innerButton":"BuyButton_innerButton__SroyI"};